<template>
  <div class="container">
    <!-- 输入框 -->
    <div class="content">
      <!-- 设置资金密码 -->
      <div class="tit">{{ $t('safe').Setfundpassword }}</div>
      <!-- 电子邮箱-->
      <!-- <div class="item">
        <van-field v-model="userInfo.email" disabled :placeholder="$t('register').Mailbox"></van-field>
      </div> -->
      <!-- 验证码 -->
      <!-- <div class="item">
        <van-field v-model="Captcha" :placeholder="$t('register').Captcha">
          <template #right-icon>
            <span style="color: var(--text_color)" @click="getCaptchaCode" v-if="countDownSec === 60">{{ tips
            }}</span>
            <span v-else style="color: var(--ntext_color)">{{ countDownSec }} s</span>
          </template>
        </van-field>
      </div> -->
      <!-- 密码 -->
      <div class="item">
        <van-field v-model="password" :type="psdType" :placeholder="$t('forgotPass').Password" :right-icon="psdType === 'password' ? 'eye' : 'closed-eye'" @click-right-icon="psdType = psdType === 'password' ? 'text' : 'password'">
        </van-field>
      </div>
      <!-- 确认密码 -->
      <div class="item">
        <van-field v-model="twoPassword" :type="twopsdType" :placeholder="$t('register').ConfirmPassword" :right-icon="twopsdType === 'password' ? 'eye' : 'closed-eye'" @click-right-icon="twopsdType = twopsdType === 'password' ? 'text' : 'password'">
        </van-field>
      </div>
      <!-- 按钮 -->
      <van-button block @click="handleSub">{{ $t('forgotPass').btn }}</van-button>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
      Captcha: '', //验证码
      uuid: '',//验证码token
      password: '',//密码
      twoPassword: '',//确认密码
      psdType: "password", //输入框类型
      twopsdType: "password", //输入框类型
      tips: this.$t('register').send,//发送验证码信息
      countDownSec: 60,
      timer: null,
      userInfo: {},
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    window.scrollTo(0, 0);
    // this.getMemberInfo()
  },
  methods: {
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
      // 绑定邮箱判断
      if (!this.userInfo.email) {
        this.$dialog.alert({
          title: this.$t('safe').BindmailboxTips,
          confirmButtonText: this.$t('public').confirm,
          confirmButtonColor: 'var(--text_color)',
        })
          .then(() => {
            this.$router.push({ name: 'BindEmail' })
          })
      }
    },
    //获取验证码
    async getCaptchaCode() {
      if (this.timer) return
      this.sendCode()
    },
    //发送验证码
    async sendCode() {
      this.countDownSec--
      this.timer = setInterval(() => {
        this.countDownSec--
        if (this.countDownSec === 0) {
          this.countDownSec = 60
          this.tips = this.$t('register').Resend
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
      const pRes = await userApi.sendCode({
        type: 'Email',
        email: this.userInfo.email
      })
      this.$toast({ message: this.$t('register').sendSuccess })
      this.uuid = pRes.uuid
    },
    // 提交
    async handleSub() {
      if (!this.checkForm()) return
      const form = {
        email: this.userInfo.email,
        uuid: this.uuid,
        captcha: this.Captcha,
        passWord: this.password,
      }
      await userApi.upFundPassword(form)
      this.$toast(this.$t('forgotPass').success)
      this.$router.go(-1)
    },
    // 表单验证
    checkForm() {
      // 验证码
      // if (!this.Captcha) {
      //   this.$toast({
      //     message: this.$t('register').placeholder4,
      //     position: 'center'
      //   })
      //   return false
      // }
      // 密码
      if (!this.password) {
        this.$toast({ message: this.$t('upPassword').newPasswordMsg })
        return false
      }
      if (!this.twoPassword) {
        this.$toast({ message: this.$t('upPassword').twoPasswordMsg })
        return false
      }
      // const regex = /^(?:(?=.*[a-zA-Z])(?=.*\d)|(?=.*[a-zA-Z])(?=.*[!@#$%^&*()_+.])|(?=.*\d)(?=.*[!@#$%^&*()_+.])).{9,}$/;
      const regex = /^\d{6}$/;
      if (!regex.test(this.password)) {
        this.$toast({ message: this.$t('upPassword').passwordTypeMsg })
        return false
      }
      if (!regex.test(this.twoPassword)) {
        this.$toast({ message: this.$t('upPassword').passwordTypeMsg })
        return false
      }
      if (this.password != this.twoPassword) {
        this.$toast({ message: this.$t('upPassword').twoinputMsg })
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .content {
    margin: 0 auto;
    max-width: 480px;

    .tit {
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
      margin-bottom: 50px;
    }

    .item {
      margin-top: 30px;

      .select_btn {
        font-size: 15px;
        color: var(--text_color);
        margin-right: 10px;
        display: flex;
        align-items: center;

        .ric {
          transform: rotate(90deg);
          margin: 0 10px 0 5px;
        }

        .line {
          height: 15px;
          background: var(--ntext_color);
          width: 1px;
        }
      }
    }

    .van-button {
      margin-top: 30px;
      background: var(--primary_color);
      height: 50px;
      border-radius: 25px;
      border: 0;
      font-size: 16px;
      color: #fff;
    }

    .van-button:hover {
      opacity: 0.8;
    }

    .footer {
      position: fixed;
      bottom: 30px;
      font-size: 12px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
        font-weight: bold;
      }
    }
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-cell {
  background: var(--background_color);
  padding: 0 10px;
  height: 50px;
  margin-bottom: 30px;
  border-radius: 10px;
  font-size: 15px;
  border: 1px solid var(--line_color);
  &:focus-within {
    border: 1px solid var(--primary_color);
    box-shadow: 1px 1px 2px var(--ntext_color);
  }
  &:hover {
    border: 1px solid var(--primary_color);
  }
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
  font-size: 15px;
  opacity: 0.9;
}

::v-deep .van-field__left-icon {
  align-items: center;
  display: flex;
}

::v-deep .van-tab {
  font-size: 15px;
  justify-content: left;
}

::v-deep .van-tab--active {
  font-weight: bold;
}

::v-deep .van-checkbox__label {
  margin-left: 5px;
  color: var(--text_color);
  font-size: 14px;
}
</style>

